import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { APP_NAME } from "../../configs/constants";
import onErrorToast from "../../utils/OnErrorToast";
import onSuccessToast from "../../utils/OnSuccessToast";
import { login } from "./../../store/auth-slice";
import classes from "./LoginPage.module.css";

const title = APP_NAME;

const LoginPage = () => {
  const userNameInputRef = useRef(null);
  const passwordInputRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const toast = useRef(null);

  const [inputUsername, setInputUsername] = useState("");
  const [inputPassword, setInputPassword] = useState("");
  const error = useSelector((state) => state.auth.error);
  const loading = useSelector((state) => state.auth.loading);
  const [errorDetail, setErrorDetail] = useState({});

  const my_url = window.location.href;
  const url = new URL(my_url);
  const MY_URL = url.origin;

  const logoUrl = `${MY_URL}/logo128.png`;
  const backgroundSmallUrl = `${MY_URL}/small-background.jpg`;

  const handleLogin = async () => {
    const username = inputUsername.trim();
    const password = inputPassword.trim();

    const responseData = await dispatch(
      login({ username: username, password: password })
    );

    if (responseData) {
      const { redirect_url } = responseData;
      onSuccessToast({ toast: toast, message: "Login Success", data: {} });

      navigate(redirect_url);
    } else {
      onErrorToast({ toast: toast, message: "Login Failed", data: {} });
    }
  };

  const handleOnKeyDownUsernameInput = (event) => {
    if (event.keyCode === 13) {
      passwordInputRef.current.focus();
    }
  };

  const handleOnKeyDownPasswordInput = (event) => {
    if (event.keyCode === 13) {
      handleLogin();
    }
  };

  return (
    <div className={`${classes.wrapper} row-center-center w-100 bg-slate-100`}>
      <Toast ref={toast} />

      <div
        className={`${classes.floatingContainer} row-center-center rounded-lg`}
      >
        <div className={`${classes.bgSection} hidden sm:block p-3`}>
          <img className="rounded-md object-fill" src={backgroundSmallUrl} />
        </div>
        <section
          className={`${classes.loginSection} w-[22rem] sm:w-[26.25rem] px-8 sm:px-14 pb-10 pt-10 sm:pt-0 sm:pb-4 `}
        >
          <div className="row-start-center w-100 gap-3 pb-5">
            <span className={`${classes.title}`}>{title}</span>
            {/* <img
              className={`${classes.logoImage}`}
              alt="logo"
              src={logoUrl}
            ></img> */}
          </div>

          <div className="col-center-start gap-2 pb-4">
            <span className={`${classes.subtitle}`}>Hey, welcome back</span>
            <span className={`${classes.subtitle2}`}>Sign in to continue</span>
          </div>
          <div className="col-center-center gap-2 mb-3">
            <div className="col-start-start gap-1 w-100 ">
              {/* <label className={`${classes.prompt}`} htmlFor="username">
                Username
              </label> */}
              <InputText
                ref={userNameInputRef}
                className={`${classes.customInput}`}
                id="username"
                placeholder="Username"
                aria-describedby="username-help"
                onChange={(e) => setInputUsername(e.target.value)}
                onKeyDown={handleOnKeyDownUsernameInput}
              />
              {errorDetail && errorDetail.username && (
                <span className={`${classes.errorLabel} `}>
                  {errorDetail.username}
                </span>
              )}
            </div>
            <div className="col-start-start gap-1 w-100">
              {/* <label className={`${classes.prompt}`} htmlFor="password">
                Password
              </label> */}
              <span></span>
              <Password
                ref={passwordInputRef}
                className={`${classes.customInput}`}
                id="password"
                placeholder="Password"
                aria-describedby="password-help"
                toggleMask
                onChange={(e) => setInputPassword(e.target.value)}
                onKeyDown={handleOnKeyDownPasswordInput}
              />
              {errorDetail && errorDetail.password && (
                <span className={`${classes.errorLabel} `}>
                  {errorDetail.password}
                </span>
              )}
            </div>
            {error && (
              <span className={`${classes.errorLabelSingle} `}>{error}</span>
            )}
          </div>
          <div className="col-center-center gap-2">
            <Button
              className={`${classes.loginButton} w-100`}
              label="Sign In"
              loading={loading}
              onClick={handleLogin}
            />
          </div>
        </section>
      </div>
    </div>
  );
};

export default LoginPage;
